/**
 * SEO Data for all pages
 * Centralized SEO meta tags, titles, and descriptions
 */

export interface PageSEO {
    title: string;
    description: string;
    keywords?: string;
    canonical?: string;
}

export const seoData: Record<string, PageSEO> = {
    // Home
    home: {
        title: 'Oficina Automóvel em Leiria | Roady Centro-Auto Leiria',
        description: 'Oficina Roady em Leiria: revisões, pneus, mudança de óleo, travões e diagnóstico. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'oficina leiria, pneus leiria, revisão automóvel leiria, mecânica leiria, roady leiria',
        canonical: 'https://roadyleiria.com/'
    },
    pneus: {
        title: 'Pneus em Leiria | Roady Centro-Auto Leiria',
        description: 'Pneus para o seu carro em Leiria. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus leiria, comprar pneus leiria, montagem pneus',
        canonical: 'https://roadyleiria.com/loja/pneus'
    },

    // Workshop (Services Overview)
    workshop: {
        title: 'Serviços de Oficina em Leiria | Roady Centro-Auto Leiria',
        description: 'Revisão, pneus, óleo, travões, alinhamento e diagnóstico em Leiria. Veja todos os serviços do Roady Leiria e peça orçamento sem compromisso.',
        keywords: 'serviços automóvel leiria, oficina leiria, mecânica leiria',
        canonical: 'https://roadyleiria.com/oficina'
    },

    // Service Details
    'revisoes-roady': {
        title: 'Revisão Automóvel em Leiria | Roady Centro-Auto Leiria',
        description: 'Revisão completa em Leiria, sem perder a garantia do seu carro. Veja o que está incluído e peça orçamento sem compromisso.',
        keywords: 'revisão automóvel leiria, revisão carro leiria, manutenção automóvel',
        canonical: 'https://roadyleiria.com/oficina/revisoes-roady'
    },
    'alinhamento': {
        title: 'Alinhamento de Direção em Leiria — Roady Centro-Auto',
        description: 'Alinhamento profissional em Leiria. Menos desgaste nos pneus, condução segura e precisa. Peça orçamento sem compromisso.',
        keywords: 'alinhamento leiria, alinhamento direção leiria, geometria leiria',
        canonical: 'https://roadyleiria.com/oficina/alinhamento'
    },
    'teste-diagnostico': {
        title: 'Diagnóstico Eletrónico em Leiria — Roady Centro-Auto',
        description: 'Diagnóstico eletrónico completo para todas as marcas. Identificação rápida e precisa de avarias. Roady Centro-Auto Leiria.',
        keywords: 'diagnóstico automóvel leiria, teste eletrónico leiria, diagnóstico carro',
        canonical: 'https://roadyleiria.com/oficina/teste-diagnostico'
    },
    'travoes': {
        title: 'Serviço de Travões em Leiria — Roady Centro-Auto',
        description: 'Substituição de pastilhas e discos de travão em Leiria. Segurança garantida com profissionais Roady.',
        keywords: 'travões leiria, pastilhas travão leiria, discos travão leiria',
        canonical: 'https://roadyleiria.com/oficina/travoes'
    },
    'amortecedores': {
        title: 'Amortecedores em Leiria — Roady Centro-Auto | Troca e Revisão',
        description: 'Troca e revisão de amortecedores em Leiria. Estabilidade e segurança com serviço Roady certificado.',
        keywords: 'amortecedores leiria, suspensão leiria, troca amortecedores',
        canonical: 'https://roadyleiria.com/oficina/amortecedores'
    },
    'inspecao': {
        title: 'Pré-Inspeção Automóvel em Leiria — Roady Centro-Auto',
        description: 'Prepare o seu carro para a inspeção com o serviço Roady em Leiria. Verificação completa e rápida.',
        keywords: 'pré-inspeção leiria, inspeção automóvel leiria, preparação inspeção',
        canonical: 'https://roadyleiria.com/oficina/inspecao'
    },
    'mecanica-geral': {
        title: 'Mecânica Automóvel em Leiria — Roady Centro-Auto',
        description: 'Mecânica automóvel completa em Leiria. Reparações e manutenção com técnicos especializados Roady.',
        keywords: 'mecânica geral leiria, reparação automóvel leiria, mecânico leiria',
        canonical: 'https://roadyleiria.com/oficina/mecanica-geral'
    },
    'ar-condicionado': {
        title: 'Carregamento de Ar Condicionado Auto em Leiria | Roady',
        description: 'Carregamento e manutenção do ar condicionado do seu carro em Leiria. Saiba quando é preciso e peça orçamento sem compromisso.',
        keywords: 'ar condicionado auto leiria, carga AC leiria, reparação AC automóvel',
        canonical: 'https://roadyleiria.com/oficina/ar-condicionado'
    },
    'baterias': {
        title: 'Baterias Automóvel em Leiria — Roady Centro-Auto',
        description: 'Teste e substituição de baterias automóvel em Leiria. Instalação com garantia Roady.',
        keywords: 'baterias auto leiria, bateria carro leiria, substituição bateria',
        canonical: 'https://roadyleiria.com/oficina/baterias'
    },
    'restauro-farois': {
        title: 'Restauro de Faróis em Leiria — Roady Centro-Auto',
        description: 'Restauro profissional de faróis automóvel. Melhore a visibilidade e segurança. Roady Leiria.',
        keywords: 'restauro faróis leiria, polimento faróis leiria, recuperação faróis',
        canonical: 'https://roadyleiria.com/oficina/restauro-farois'
    },
    'lavagem': {
        title: 'Lavagem Auto em Leiria — Roady Centro-Auto',
        description: 'Serviços de lavagem automóvel completos em Leiria. Interior e exterior com profissionais Roady.',
        keywords: 'lavagem auto leiria, limpeza carro leiria, lavagem completa',
        canonical: 'https://roadyleiria.com/oficina/lavagem'
    },
    'servicos-oficina': {
        title: 'Plano de Serviços Oficina — Roady Centro-Auto',
        description: 'Planos de serviços e manutenção para a sua oficina. Soluções completas Roady em Leiria.',
        keywords: 'plano serviços leiria, manutenção oficina leiria',
        canonical: 'https://roadyleiria.com/oficina/servicos-oficina'
    },

    // Store & Categories
    store: {
        title: 'Loja Auto em Leiria — Roady Centro-Auto | Peças e Acessórios',
        description: 'Óleos, acessórios, produtos auto, limpeza e manutenção. Loja Roady Leiria.',
        keywords: 'loja auto leiria, peças automóvel leiria, acessórios auto leiria',
        canonical: 'https://roadyleiria.com/loja'
    },
    'loja-eletricidade': {
        title: 'Eletricidade Automóvel — Loja Roady Leiria',
        description: 'Componentes elétricos, baterias e acessórios elétricos para automóvel. Roady Leiria.',
        keywords: 'eletricidade auto leiria, componentes elétricos carro',
        canonical: 'https://roadyleiria.com/loja/eletricidade'
    },
    'loja-equipamento-interior': {
        title: 'Equipamento Interior Auto — Loja Roady Leiria',
        description: 'Acessórios e equipamentos para interior do automóvel. Qualidade garantida Roady.',
        keywords: 'equipamento interior auto, acessórios interior carro leiria',
        canonical: 'https://roadyleiria.com/loja/equipamento-interior'
    },
    'loja-equipamento-exterior': {
        title: 'Equipamento Exterior Auto — Loja Roady Leiria',
        description: 'Acessórios e equipamentos para exterior do automóvel. Loja Roady Leiria.',
        keywords: 'equipamento exterior auto, acessórios exterior carro leiria',
        canonical: 'https://roadyleiria.com/loja/equipamento-exterior'
    },
    'loja-lubrificantes': {
        title: 'Lubrificantes e Óleos Auto — Loja Roady Leiria',
        description: 'Óleos motor, lubrificantes e produtos de manutenção. Marcas de confiança na Roady Leiria.',
        keywords: 'óleo motor leiria, lubrificantes auto leiria',
        canonical: 'https://roadyleiria.com/loja/lubrificantes'
    },
    'loja-manutencao': {
        title: 'Produtos de Manutenção Auto — Loja Roady Leiria',
        description: 'Produtos de manutenção e cuidado automóvel. Roady Leiria.',
        keywords: 'produtos manutenção auto, cuidado automóvel leiria',
        canonical: 'https://roadyleiria.com/loja/manutencao'
    },
    'loja-pecas-tecnicas': {
        title: 'Peças Técnicas Auto — Loja Roady Leiria',
        description: 'Peças técnicas e componentes para automóvel. Qualidade garantida Roady.',
        keywords: 'peças técnicas auto leiria, componentes carro',
        canonical: 'https://roadyleiria.com/loja/pecas-tecnicas'
    },
    'loja-pneus': {
        title: 'Pneus em Leiria | Roady Centro-Auto Leiria',
        description: 'Pneus para o seu carro em Leiria. Aconselhamento na escolha, montagem e equilibragem por técnicos Roady. Peça orçamento sem compromisso.',
        keywords: 'pneus leiria, comprar pneus leiria, montagem pneus',
        canonical: 'https://roadyleiria.com/loja/pneus'
    },
    'loja-som-multimedia-navegacao': {
        title: 'Som, Multimédia e Navegação — Loja Roady Leiria',
        description: 'Sistemas de som, multimédia e navegação GPS para automóvel. Roady Leiria.',
        keywords: 'som auto leiria, GPS carro leiria, multimédia automóvel',
        canonical: 'https://roadyleiria.com/loja/som-multimedia-navegacao'
    },
    'loja-ferramentas': {
        title: 'Ferramentas Auto — Loja Roady Leiria',
        description: 'Ferramentas profissionais e acessórios para manutenção automóvel. Roady Leiria.',
        keywords: 'ferramentas auto leiria, ferramentas mecânica',
        canonical: 'https://roadyleiria.com/loja/ferramentas'
    },

    // Other Pages
    budget: {
        title: 'Peça Orçamento Automóvel em Leiria | Roady Leiria',
        description: 'Peça orçamento para revisão, pneus, travões ou mudança de óleo no Roady Leiria. Diga-nos o que o carro precisa e respondemos com um valor claro.',
        keywords: 'orçamento auto leiria, pedir orçamento oficina leiria',
        canonical: 'https://roadyleiria.com/orcamento'
    },
    mobility: {
        title: 'Mobilidade Urbana Leiria — Roady Centro-Auto',
        description: 'Bicicletas e trotinetes elétricas em Leiria. Assistência e apoio Roady.',
        keywords: 'mobilidade leiria, bicicletas elétricas leiria, trotinetes leiria',
        canonical: 'https://roadyleiria.com/mobilidade'
    },
    recruitment: {
        title: 'Recrutamento — Roady Centro-Auto Leiria',
        description: 'Junte-se à equipa Roady Centro-Auto Leiria. Procuramos talento para o setor automóvel. Envie candidatura.',
        keywords: 'emprego leiria, trabalho oficina leiria, recrutamento roady',
        canonical: 'https://roadyleiria.com/recrutamento'
    },
    contact: {
        title: 'Contactos e Horário | Roady Centro-Auto Leiria',
        description: 'Morada, horário, telefone e WhatsApp do Roady Centro-Auto Leiria. Fale connosco ou peça orçamento sem compromisso.',
        keywords: 'contacto roady leiria, telefone oficina leiria, morada roady',
        canonical: 'https://roadyleiria.com/contacto'
    },
    wecall: {
        title: 'Ligamos-lhe — Roady Centro-Auto Leiria',
        description: 'Deixe os seus dados e ligamos-lhe. Atendimento personalizado Roady Leiria.',
        keywords: 'contacto roady leiria, ligação gratuita',
        canonical: 'https://roadyleiria.com/ligamos'
    },
    wishlist: {
        title: 'Lista de Desejos — Roady Centro-Auto Leiria',
        description: 'Guarde os seus produtos favoritos na lista de desejos. Loja Roady Leiria.',
        canonical: 'https://roadyleiria.com/lista-desejos'
    },

    // Legal Pages
    cookies: {
        title: 'Política de Cookies — Roady Centro-Auto Leiria',
        description: 'Política de cookies do website Roady Centro-Auto Leiria. Saiba como utilizamos cookies.',
        canonical: 'https://roadyleiria.com/politica-cookies'
    },
    privacy: {
        title: 'Política de Privacidade — Roady Centro-Auto Leiria',
        description: 'Política de privacidade e proteção de dados do Roady Centro-Auto Leiria.',
        canonical: 'https://roadyleiria.com/politica-privacidade'
    },
    terms: {
        title: 'Termos e Condições — Roady Centro-Auto Leiria',
        description: 'Termos e condições de utilização do website Roady Centro-Auto Leiria.',
        canonical: 'https://roadyleiria.com/termos-condicoes'
    }
};

/**
 * Get SEO data for a service page
 */
export const getServiceSEO = (serviceSlug: string): PageSEO => {
    return seoData[serviceSlug] || seoData.workshop;
};

/**
 * Get SEO data for a store category page
 */
export const getStoreCategorySEO = (categorySlug: string): PageSEO => {
    const key = `loja-${categorySlug}`;
    return seoData[key] || seoData.store;
};

